// @flow

import type { Merchant } from '@tectonics/prs/merchant/types';
import { getMerchantConfig } from './get-merchant-config';

export function getCustomMerchantName(merchant: Merchant): ?string {
  const config = getMerchantConfig(merchant);
  const customization = config && config.payment_page_customization;
  const customName = customization && customization.merchant && customization.merchant.name;

  return customName || null;
}
